ajaxifyCollection = function(isSearch, triggerFirstCall, getNextAvailablePage){

	//code borrowed from https://github.com/Elkfox/Ajaxify
	var linkParent = '.pagination-ajax'; // Class of pagination container
	var parentContainer = 'html'; // All of the content selector used to detect scroll bottom distance
	var endlessScrollContainer = '.EndlessScroll'; // Selector for endless scroll pages
	var endlessOffset = 700; // Offset the distance from the bottom of the page
	var ajaxinateContainer = '.Ajaxinate'; // ID Selector for ajax pagination pages
	var ajaxinateLink = '.page a'; // Class Selector for ajax pagination links
	var fade = 'fast'; // fade speed
	var textChange = 'Loading'; // Text whilst loading content

	var linkElem;
	var contentContainer;
	var pageNumber;
	var pageType;
	var action;
	var moreURL;
	var moreURLCheck;
	var currentPage;

	var gettingContent = false;

	var maxPages = $('.pagination-ajax').data('pages');

	var loadedLastPage = false;

	var productClass= ".product-col";

	$.loadMore = function() {
		// console.log('loadMore');
		if(isSearch && moreURL !== undefined) {
			moreURLCheck = moreURL.substring(moreURL.lastIndexOf("?page=")+1,moreURL.lastIndexOf("&q="));
			moreURLCheck = moreURLCheck.split("page=");
			var pageNum = null;
			if(moreURLCheck.indexOf('&')) {
				pageNum = moreURLCheck[1].split("&");
				currentPage = pageNum[0];
			} else {
				currentPage = moreURLCheck[1];
			}
		}
		else if (isSearch != true && moreURL !== undefined) {
			moreURLCheck = moreURL.split("page=");
			var pageNum = null;
			if(moreURLCheck.indexOf('&')) {
				pageNum = moreURLCheck[1].split("&");
				currentPage = pageNum[0];
			} else {
				currentPage = moreURLCheck[1];
			}
		}
		else {
			currentPage = null;
		}

	   if (currentPage != null && moreURL.length && currentPage <= maxPages && loadedLastPage == false){
		   $(linkElem).css('opacity', 0);
		   $('.loader').show();
		   gettingContent = true;
		 $.ajax({
		   type: 'GET',
		   dataType: 'html',
		   url: moreURL,
		   success: function(data) {
			if(currentPage == maxPages) {
				loadedLastPage = true;
			}

			var filteredData = $(data).find(contentContainer);

			var filteredDataProducts = filteredData[0].innerHTML;

			var newPagination = $(data).find(".pagination-ajax").length > 0 ? $(data).find(".pagination-ajax") : '';

			if(newPagination) {
				$(".pagination-ajax").html(newPagination);
			} else {
				$(".pagination-ajax").html('');
			}

			var hasLink = $(linkElem).last().attr('href');

			gettingContent = false;

			moreURL = $(linkElem).last().attr('href');
			

			if(!gettingContent && hasLink && !triggerFirstCall && filteredDataProducts.trim().length === 0 || filteredDataProducts.trim() === '') {

				var nextPagination = $(data).find(".pagination-ajax");

				if(nextPagination.length > 0 && hasLink) {
					
					setTimeout(function() {
						$.loadMore();
					}, 150);
					
					return;
				} else {
					if($(productClass).length === 0) {
						$(".EndlessScroll").append("<div class='no-products text-center'><p>{{ 'collections.general.no_matches' | t }}</p></div>");
					}
				}
			}

			var newProdHtml = $(filteredDataProducts);


			$(contentContainer).append(newProdHtml).hide().fadeIn(fade);


			var newProducts = newProdHtml;

			collectionGetVariations(newProducts);

			$(".swatch").click(function(){
				$(this).closest(productClass).find(".swatch").removeClass("swatch-active");
				$(this).addClass("swatch-active");
				var swatchName = $(this).attr('class').split(' ')[1];

				var colorName = swatchName.replace('swatch-', '');
				var currentSwatch = '.' + $(this).attr('class').split(' ')[1];
				var imageContainer = '';
				var findImage = '.image-' + colorName;

				var variantLink = $(this).closest(productClass).find(findImage).find(".collection-product-image-link").attr('href');

				$(this).closest(productClass).find(".product-image-swatch").css("z-index", "-1");

				$(this).closest(productClass).find(findImage).css("z-index", "2");
				$(this).closest(productClass).find(".product-block-name").attr('href', variantLink);
			});

			//  ModalQuickShop();
			// console.log($(productClass).length);

			if($(productClass).length < 8 && hasLink) {
				
				setTimeout(function() {
					$.loadMore();
				}, 150);
			}

			 $(linkElem).css('opacity', 0);
			 $('.loader').hide();
			 
			 if (pageType == 'endlessScroll') {
			   $.endlessScroll();
			 }
		   },
    		timeout:15000,
			error: function(jqXHR, textStatus, errorThrown) {
				$('.loader').hide();
		        if(textStatus==="timeout") {
					$(linkElem).text("Load more");
					$(linkElem).css('opacity', 1);
		        }
		    }
		 });
	   } else {
		//    console.log("didn't fetch");
	   }
	 };


	 $.endlessScroll = function() {
	  action = 'scroll load resize';
	  $(window).on( action, function() {
        // console.log('endlessscroll');
		contentContainer = endlessScrollContainer;
		moreURL = $(linkElem).last().attr('href');
		pageType = 'endlessScroll';
		$(linkElem).text(textChange);

		var bottom;
		var docTop;

		if ($(contentContainer+':last-of-type '+linkElem).length || $(contentContainer).length == 1){
			if($(contentContainer).length == 1) {
				moreURL = $(linkElem).last().attr('href');
			}
			else {
				moreURL = $(linkElem).last().attr('href');
			}
		  bottom = $( ".collection-section" ).outerHeight();
		  docTop = ($(parentContainer).scrollTop() + $("#shopify-section-footer").height());

		// console.log(bottom, docTop);

		  
          if( docTop > bottom && gettingContent == false) {
			$(window).off(action);
			  $.loadMore();
		  }
		}
	  });
	};

	if ( $( endlessScrollContainer ).length ) {
	  linkElem = linkParent+' a';
	  $.endlessScroll();
	}

	if(triggerFirstCall && gettingContent == false) {
		contentContainer = endlessScrollContainer;
		moreURL = $(linkElem).last().attr('href');

		$.loadMore();
	}

	if(getNextAvailablePage && linkParent.length > 0 && gettingContent == false && $(productClass).length === 0) {
		contentContainer = endlessScrollContainer;
		moreURL = $(linkElem).last().attr('href');

		$.loadMore();
		
	}
};


// ajaxifyCollection = function(isSearch, triggerFirstCall){

// 	//code borrowed from https://github.com/Elkfox/Ajaxify
// 	var linkParent = '.pagination-ajax'; // Class of pagination container
// 	var parentContainer = 'html'; // All of the content selector used to detect scroll bottom distance
// 	var endlessScrollContainer = '.EndlessScroll'; // Selector for endless scroll pages
// 	var endlessOffset = 700; // Offset the distance from the bottom of the page
// 	var ajaxinateContainer = '.Ajaxinate'; // ID Selector for ajax pagination pages
// 	var ajaxinateLink = '.page a'; // Class Selector for ajax pagination links
// 	var fade = 'fast'; // fade speed
// 	var textChange = 'Loading'; // Text whilst loading content

// 	var linkElem;
// 	var contentContainer;
// 	var pageNumber;
// 	var pageType;
// 	var action;
// 	var moreURL;
// 	var moreURLCheck;
// 	var currentPage;

// 	var gettingContent = false;

// 	var maxPages = $('.pagination-ajax').data('pages');

// 	var loadedLastPage = false;
  
//     var productClass = ".product-col";

// 	$.loadMore = function() {
// 		if(isSearch && moreURL !== undefined) {
// 			moreURLCheck = moreURL.substring(moreURL.lastIndexOf("?page=")+1,moreURL.lastIndexOf("&q="));
// 			moreURLCheck = moreURLCheck.split("page=");
// 			var pageNum = null;
// 			if(moreURLCheck.indexOf('&')) {
// 				pageNum = moreURLCheck[1].split("&");
// 				currentPage = pageNum[0];
// 			} else {
// 				currentPage = moreURLCheck[1];
// 			}
// 		}
// 		else if (isSearch != true && moreURL !== undefined) {
// 			moreURLCheck = moreURL.split("page=");
// 			var pageNum = null;
// 			if(moreURLCheck.indexOf('&')) {
// 				pageNum = moreURLCheck[1].split("&");
// 				currentPage = pageNum[0];
// 			} else {
// 				currentPage = moreURLCheck[1];
// 			}
// 		}
// 		else {
// 			currentPage = null;
// 		}

// 	   if (currentPage != null && moreURL.length && currentPage <= maxPages && loadedLastPage == false){
// 		   $(linkElem).css('opacity', 0);
// 		   $('.loader').show();
// 		   gettingContent = true;
// 		 $.ajax({
// 		   type: 'GET',
// 		   dataType: 'html',
// 		   url: moreURL,
// 		   success: function(data) {
// 			if(currentPage == maxPages) {
// 				loadedLastPage = true;
// 			}
// 			// $(".pagination-ajax").css("position", "absolute");
// 			// $(".loader").css("position", "absolute");

// 			var filteredData = $(data).find(contentContainer);

// 			var filteredDataProducts = filteredData[0].innerHTML;

// 			var newProdHtml = $(filteredDataProducts);

// 			var newPagination = $(data).find(".pagination-ajax");

// 			$(contentContainer).append(newProdHtml).hide().fadeIn(fade);

// 			$(".pagination-ajax").html(newPagination);


// 			var newProducts = newProdHtml;

// 			collectionGetVariations(newProducts);

// 			$(".swatch").click(function(){
// 				$(this).closest(productClass).find(".swatch").removeClass("swatch-active");
// 				$(this).addClass("swatch-active");
// 				var swatchName = $(this).attr('class').split(' ')[1];

// 				var colorName = swatchName.replace('swatch-', '');
// 				var currentSwatch = '.' + $(this).attr('class').split(' ')[1];
// 				var imageContainer = '';
// 				var findImage = '.image-' + colorName;

// 				var variantLink = $(this).closest(productClass).find(findImage).find(".collection-product-image-link").attr('href');

// 				$(this).closest(productClass).find(".product-image-swatch").css("z-index", "-1");

// 				$(this).closest(productClass).find(findImage).css("z-index", "2");
// 				$(this).closest(productClass).find(".product-block-name").attr('href', variantLink);
// 			});

// 			//  ModalQuickShop();

// 			 $(linkElem).css('opacity', 0);
// 			 $('.loader').hide();
// 			 gettingContent = false;
// 			 if (pageType == 'endlessScroll') {
// 			   $.endlessScroll();
// 			 }
// 		   },
//     		timeout:15000,
// 			error: function(jqXHR, textStatus, errorThrown) {
// 				$('.loader').hide();
// 		        if(textStatus==="timeout") {
// 					$(linkElem).text("Load more");
// 					$(linkElem).css('opacity', 1);
// 		        }
// 		    }
// 		 });
// 	   } else {
// 		//    console.log("didn't fetch");
// 	   }
// 	 };


// 	 $.endlessScroll = function() {
// 	  action = 'scroll load resize';
// 	  $(window).on( action, function() {
//         // console.log('endlessscroll');
// 		contentContainer = endlessScrollContainer;
// 		moreURL = $(linkElem).last().attr('href');
// 		pageType = 'endlessScroll';
// 		$(linkElem).text(textChange);

// 		var bottom;
// 		var docTop;

// 		if ($(contentContainer+':last-of-type '+linkElem).length || $(contentContainer).length == 1){
// 			if($(contentContainer).length == 1) {
// 				moreURL = $(linkElem).last().attr('href');
// 			}
// 			else {
// 				moreURL = $(linkElem).last().attr('href');
// 			}
// 		  bottom = $( ".collection-section" ).outerHeight();
// 		  docTop = ($(parentContainer).scrollTop() + $("#shopify-section-footer").height());

// 		// console.log(bottom, docTop);

		  
//           if( docTop > bottom && gettingContent == false) {
// 			$(window).off(action);
// 			  $.loadMore();
// 		  }
// 		}
// 	  });
// 	};

// 	if ( $( endlessScrollContainer ).length ) {
// 	  linkElem = linkParent+' a';
// 	  $.endlessScroll();
// 	}

// 	if(triggerFirstCall && gettingContent == false) {
// 		contentContainer = endlessScrollContainer;
// 		moreURL = $(linkElem).last().attr('href');

// 		$.loadMore();
// 	}
// };
